import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Spanish translations
import esCommon from '@/locales/es/common.json';
import esAuth from '@/locales/es/auth.json';
import esStudents from '@/locales/es/students.json';
import esTasks from '@/locales/es/tasks.json';
import esCalendar from '@/locales/es/calendar.json';
import esSettings from '@/locales/es/settings.json';
import esNotifications from '@/locales/es/notifications.json';
import esAi from '@/locales/es/ai.json';
import esStudyPlan from '@/locales/es/studyPlan.json';
import esGrades from '@/locales/es/grades.json';
import esUniforms from '@/locales/es/uniforms.json';

// English translations
import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enStudents from '@/locales/en/students.json';
import enTasks from '@/locales/en/tasks.json';
import enCalendar from '@/locales/en/calendar.json';
import enSettings from '@/locales/en/settings.json';
import enNotifications from '@/locales/en/notifications.json';
import enAi from '@/locales/en/ai.json';
import enStudyPlan from '@/locales/en/studyPlan.json';
import enGrades from '@/locales/en/grades.json';
import enUniforms from '@/locales/en/uniforms.json';

const resources = {
  es: {
    common: esCommon,
    auth: esAuth,
    students: esStudents,
    tasks: esTasks,
    calendar: esCalendar,
    settings: esSettings,
    notifications: esNotifications,
    ai: esAi,
    studyPlan: esStudyPlan,
    grades: esGrades,
    uniforms: esUniforms,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    students: enStudents,
    tasks: enTasks,
    calendar: enCalendar,
    settings: enSettings,
    notifications: enNotifications,
    ai: enAi,
    studyPlan: enStudyPlan,
    grades: enGrades,
    uniforms: enUniforms,
  },
};

// Safely get language from localStorage
function getStoredLanguage(): string {
  try {
    const stored = localStorage.getItem('frappi-ui-storage');
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed?.state?.language || 'es';
    }
  } catch {
    // Invalid JSON or missing, fallback to default
  }
  return 'es';
}

i18n.use(initReactI18next).init({
  resources,
  lng: getStoredLanguage(),
  fallbackLng: 'es',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
